import { render } from "./CopyToClipBoard.vue?vue&type=template&id=5dcf5f34&scoped=true"
import script from "./CopyToClipBoard.vue?vue&type=script&lang=js"
export * from "./CopyToClipBoard.vue?vue&type=script&lang=js"

import "./CopyToClipBoard.vue?vue&type=style&index=0&id=5dcf5f34&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcf5f34"]])

export default __exports__